module.exports = __webpack_public_path__ + "static/media/01.7583328c.png";